import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { removeFavorite, addFavorite } from 'redux-implementations/favorites';
import { DialogNames } from 'redux-implementations/dialog';
import { AppDispatch } from 'redux-implementations/makeStore';
import FacebookPixel from 'lib/FacebookPixel';
import { addedToFavorites } from 'lib/GoogleAdWords';
import { useIsSignedIn } from './useIsSignedIn';
import { useIsVinFavorited } from './useFavoritedVins';
import useDialog from './useDialog';

export interface UseVehicleFavoriteInterface {
  isFavorited: boolean;
  unfavorite: () => void;
  favorite: () => void;
}

export default function useFavorite(vin: string): UseVehicleFavoriteInterface {
  const dispatch = useDispatch<AppDispatch>();
  const [favoriteAfterSignIn, setFavoriteAfterSignIn] = useState(false);
  const isSignedIn = useIsSignedIn();
  const isFavorited = useIsVinFavorited(vin);
  const { open } = useDialog(DialogNames.Auth);

  function unfavorite(): void {
    if (isFavorited) {
      dispatch<any>(removeFavorite(vin));
    }
  }

  useEffect(() => {
    if (isSignedIn && favoriteAfterSignIn) {
      setFavoriteAfterSignIn(false);
      dispatch<any>(addFavorite(vin));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, favoriteAfterSignIn]);

  function favorite(): void {
    FacebookPixel.trackFavorite();
    addedToFavorites(vin);
    if (isSignedIn) {
      dispatch<any>(addFavorite(vin));
    } else {
      setFavoriteAfterSignIn(true);
      open();
    }
  }

  return { isFavorited, unfavorite, favorite };
}
